import { PersonFill } from 'react-bootstrap-icons';
import {
  CustomStyledCard,
  StyledDeliveryAddressCardDetails,
  StyledDeliveryAddressesCardTitle,
  StyledOrderSection
} from '../../utils/OrderStyles';
import { useTranslation } from 'react-i18next';
import {
  IOrderInformationsForm,
  IOrderInformationsOperaBusinessForm
} from '@features/order/utils/orderInterfaces';
import OrderRecapEditLink from '@features/order/orderRecap/components/OrderRecapEditLink';
import { OrderSections } from '@features/order/utils/OrderHelper';
import React from 'react';

const OrderRecapDeliveryAddressSection = ({
  editable,
  orderInformation
}: {
  editable: boolean;
  orderInformation: IOrderInformationsForm | IOrderInformationsOperaBusinessForm;
}) => {
  const { t } = useTranslation();

  return (
    <StyledOrderSection style={{ marginTop: editable ? '24px' : '0' }}>
      <div className="section-title">
        {t('features.order.orderRecap.orderRecapSections.deliveryAddress', 'ONT Delivery Address')}
      </div>
      <CustomStyledCard>
        {orderInformation.hasDeliveryAddress && (
          <>
            <div>
              <StyledDeliveryAddressesCardTitle as="h6">
                {orderInformation.deliveryAddress}, {orderInformation.deliveryPostalCode}{' '}
                {orderInformation.deliveryCity}
              </StyledDeliveryAddressesCardTitle>
              <StyledDeliveryAddressCardDetails>
                <PersonFill /> {orderInformation?.deliveryFirstName}{' '}
                {orderInformation?.deliveryLastName}
                <br />
                {orderInformation?.deliveryPhone}
                {orderInformation?.deliverySite && (
                  <>
                    <br />
                    {t(
                      'features.order.orderRecap.orderRecapSections.deliverySite',
                      'Delivery Site'
                    )}
                    : {orderInformation?.deliverySite}
                  </>
                )}
              </StyledDeliveryAddressCardDetails>
            </div>
          </>
        )}
      </CustomStyledCard>
      {editable && (
        <OrderRecapEditLink stepToGo={3} anchorKey={OrderSections.ComplementaryInformations} />
      )}
    </StyledOrderSection>
  );
};

export default OrderRecapDeliveryAddressSection;
